import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider, useForm } from 'react-hook-form';
export const EventRegistrationFormProvider = ({ children }) => {
    const methods = useForm({
        mode: 'all',
        reValidateMode: 'onChange'
    });
    return _jsx(FormProvider, { ...methods, children: children });
};
